/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getBaseServiceConfig } from 'apps/console-core/src/Services/_base';
import { useAiServiceStore } from 'dxpConsoleCore-mf/State';
import { AiService } from '../../Ai.service';
import { AiServiceConfiguration } from '../../Ai.service.config';

/**
 * Get the AI Service.
 */
export const getAiService = (): AiService => {
  const baseServiceConfig = getBaseServiceConfig();

  const { updateAiService } = useAiServiceStore.getState();
  const { aiService }: { aiService: AiService | null } = useAiServiceStore.getState();

  if (!aiService) {
    const aiServiceConfiguration: AiServiceConfiguration = {
      ...baseServiceConfig,
    };
    const newAiService = new AiService(aiServiceConfiguration);
    updateAiService(newAiService);

    return newAiService;
  }

  return aiService;
};
